import { render, staticRenderFns } from "./superSearch.vue?vue&type=template&id=026b5b82&"
import script from "./superSearch.vue?vue&type=script&lang=js&"
export * from "./superSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/superSearch.vue"
export default component.exports